export default __webpack_public_path__ + "static/testimonial2-22c8196cc036312ffe6ea4cac51d5a61.jpg";